var _polygon, _rect, _rect2, _path, _path2, _rect3, _polygon2, _path3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIvantiLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 517.6,
    height: 184.4,
    viewBox: "0 0 517.6 184.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "497.2 20.4 497.2 50.9 517.6 50.9 517.6 0 466.7 0 466.7 20.4 497.2 20.4",
    fill: "#ff1515"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 466.7,
    y: 30.5,
    width: 20.3,
    height: 20.35,
    fill: "#ff1515"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 20.4,
    width: 30.5,
    height: 30.52,
    fill: "#ff1515"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.3,113.7c0-4.8-.2-17.2-7.2-25.6-10.3-12-28.5-13.4-37.1-13.4s-22.1,1.6-31.6,8.4-11.5,19-11.8,24.6h30a16.13,16.13,0,0,1,2.2-9.3,14,14,0,0,1,11.6-5.8c2.9,0,10.9,1.1,13.6,8.7,1.2,3.7,1.4,7,1.4,13.8-10.1,0-28.4,0-41.2,5.8-19.2,8.9-22.1,24.1-22.1,32.4a32.42,32.42,0,0,0,9.1,22.9c4.1,3.9,10.9,8.2,26,8.2,5.7,0,19.6,0,31.1-16.7a85.48,85.48,0,0,0,1,14.2H251a122.54,122.54,0,0,1-2.5-26.4Zm-34.6,44.9a17.49,17.49,0,0,1-13,6c-10.1,0-14.9-7.8-14.9-14.8,0-12.4,14-18.6,33.6-17,0,11.2-.4,19.2-5.7,25.8Z",
    fill: "#ff1515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M425.7,51.3l-30.3,8.3v18h-20V97.8h20v57.9c0,8.7,0,28.1,30.7,28.1a93.52,93.52,0,0,0,23.7-3.3v-20a80.65,80.65,0,0,1-10.3.6c-13.6,0-13.6-6-13.8-15.5V97.8h24.7V77.6H425.7Z",
    fill: "#ff1515"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 77.6,
    width: 30.5,
    height: 104.35,
    fill: "#ff1515"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "124.9 77.6 101 148.3 77.5 77.6 44.7 77.6 82.9 181.9 116.8 181.9 154.4 77.6 124.9 77.6",
    fill: "#ff1515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.7,94.5c-2.7-7.2-11.4-19.6-31.8-19.6-22.7,0-30.9,13.4-33.8,18.1l-.8-15.4H266c.6,7.2.6,18.3.6,18.7v85.6h30.7v-61c0-8.1,1.9-13.2,3.7-15.9a19.11,19.11,0,0,1,15.9-8,16.1,16.1,0,0,1,14.9,8.8c1.6,3.3,1.6,7,1.6,11.4v64.7h31.1V125.6C364.5,106.2,363.9,100.9,361.7,94.5Z",
    fill: "#ff1515"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 466.7,
    y: 77.6,
    width: 30.5,
    height: 104.35,
    fill: "#ff1515"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvantiLogo);
export default __webpack_public_path__ + "static/media/IvantiLogo.981f03fe8207d205cbd978e097369fb5.svg";
export { ForwardRef as ReactComponent };